import { RoutesComponent } from "./routes/RoutesComponent";
import { ToastContainer } from "react-toastify";
import { SkeletonTheme } from "react-loading-skeleton";
import useModal from "./hooks/useModal";
import { Colors } from "./utils/constants/style";
import "react-toastify/dist/ReactToastify.css";
import "react-loading-skeleton/dist/skeleton.css";
import "react-datepicker/dist/react-datepicker.css";
import ptBR from "date-fns/locale/pt-BR";
import { registerLocale } from "react-datepicker";
import { APIProvider } from "@vis.gl/react-google-maps";
import { useEffect } from "react";
import { useStore } from "./store/useStore";
registerLocale("pt-BR", ptBR);

const App: React.FC<{}> = () => {
  // const { isModalOpen, modalContent } = useModal();
  const modalStack = useStore((state) => state.modal.modalStack);
  const bulkRefreshPayRoll = useStore((state) => state.timeManager.bulkRefreshPayRoll);
  const handleBeforeUnload = () => {
    localStorage.setItem("tabsProcessing", "0");
  };

  useEffect(() => {
    const payrollProcess = JSON.parse(sessionStorage.getItem("payrollProcess") || "{}");
    const tabsProcessing = localStorage.getItem("tabsProcessing");

    if(tabsProcessing === "1") {  
      sessionStorage.removeItem("payrollProcess");
    } else if(tabsProcessing !== undefined || tabsProcessing === "0") {
      window.addEventListener("beforeunload", handleBeforeUnload);
    }

    const { payRollGroup, collaboratorIds } = payrollProcess;
    if (payRollGroup?.id && collaboratorIds?.length > 0 && tabsProcessing === "0" as string) {
      bulkRefreshPayRoll({
        payRollGroupId: payRollGroup.id,
        collaboratorIds,
      });
      localStorage.setItem("tabsProcessing", "1");
    }
  }, [bulkRefreshPayRoll]); 

  return (
    <APIProvider
      apiKey={process.env.REACT_APP_GOOGLE_MAPS_API as string}
      libraries={["marker"]}
    >
      <div className="App text-black text-base">
        <SkeletonTheme baseColor={Colors.gray_1} highlightColor="#E9EAED">
          <RoutesComponent />
          <ToastContainer />
          {/* {isModalOpen && modalContent} */}
          {
            modalStack.map((modalContent, index) => (
              <div key={index} className="modal-container">
                {modalContent}
              </div>
            ))
          }
        </SkeletonTheme>
      </div>
    </APIProvider>
  );
};

export default App;
